import { userHeartbeatAPI } from 'api';
import { useEffect, useRef } from 'react';

const CroppingHeartbeat = () => {

  const isWindowActiveRef = useRef(true);
  const isUserInteractingRef = useRef(false);
  const interactionTimeoutRef = useRef(null);

  const sendHeartbeat = async () => {
    try {
      const response = await userHeartbeatAPI();
      if (!response.success) {
        console.error('Failed to send heartbeat:', response.statusText);
      }
    } catch (error) {
      console.error('Error sending heartbeat:', error);
    }
  };

  useEffect(() => {
    const handleFocus = () => { isWindowActiveRef.current = true; };
    const handleBlur = () => { isWindowActiveRef.current = false; };
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    const handleUserInteraction = () => {
      isUserInteractingRef.current = true;

      // Reset interaction state after 30 seconds of inactivity
      if (interactionTimeoutRef.current) {
        clearTimeout(interactionTimeoutRef.current);
      }
      interactionTimeoutRef.current = setTimeout(() => {
        isUserInteractingRef.current = false;
      }, 30000);
    };
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach(event => window.addEventListener(event, handleUserInteraction));

    const intervalId = setInterval(() => {
      if (isWindowActiveRef.current && isUserInteractingRef.current) {
        sendHeartbeat();
      }
    }, 60000);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      events.forEach(event => window.removeEventListener(event, handleUserInteraction));
      clearInterval(intervalId);
      if (interactionTimeoutRef.current) {
        clearTimeout(interactionTimeoutRef.current);
      }
    };
  }, []);

  return null;
};

export default CroppingHeartbeat;
